import { render, staticRenderFns } from "./consultations-medecin.html?vue&type=template&id=1e27bdd2&scoped=true&external"
import script from "./consultations-medecin.js?vue&type=script&lang=js&external"
export * from "./consultations-medecin.js?vue&type=script&lang=js&external"
import style0 from "./consultations-medecin.scss?vue&type=style&index=0&id=1e27bdd2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e27bdd2",
  null
  
)

export default component.exports